import { aboutPath, collabsPath, playlistsPath, rootPath } from "@/routes"

export interface PublicNavItem {
  label: string
  href: string
}

// The public wayfinding set. PublicHeader and DashboardHeader must carry the
// same links by design, so this is the one nav list that lives centrally
// rather than as a per-component array.
export const publicNavItems: PublicNavItem[] = [
  { label: "Featured", href: rootPath() },
  { label: "Collabs", href: collabsPath() },
  { label: "Playlists", href: playlistsPath() },
  { label: "About", href: aboutPath() },
]
